import gameSettings from '../constants/gameSettings';
import { clamp } from '../helpers/clamp';

// Объект с равноускоренным движением
export default class GameMovementModel {
    #startDistance;

    #velocity;
    #fullVelocityWithBonus;
    #acceleration;
    #distance;
    #startVelocity;
    #velocityModifiers = [];
    #minVelocity;
    #maxVelocity;

    constructor() {
        this.#minVelocity = gameSettings.minVelocity * gameSettings.speedOfGame;
        this.#maxVelocity = gameSettings.maxVelocity * gameSettings.speedOfGame;
    }

    updateDistanceAndVelocity(deltaT) {
        const bonusVelocity = this.getCombinedVelocityModifiers(deltaT);

        const fullCurrentVelocity = clamp(this.#velocity + bonusVelocity, this.#minVelocity, this.#maxVelocity);
        const newVelocity = clamp(this.#velocity + this.#acceleration * deltaT, this.#minVelocity, this.#maxVelocity);

        this.#distance += fullCurrentVelocity * deltaT;
        this.#velocity = newVelocity;
        this.#fullVelocityWithBonus = fullCurrentVelocity;
    }

    addVelocityModifier(value, duration, endCallback) {
        if (!duration || duration < 0) {
            const newVelocity = this.#velocity + value;

            this.#velocity = clamp(newVelocity, this.#minVelocity, this.#maxVelocity);
        } else {
            this.#velocityModifiers.push({
                value,
                duration: duration / 1000,
                remainingDuration: duration / 1000,
                endCallback
            });
        }
    }

    resetVelocityModifiers() {
        this.#velocityModifiers = [];
    }

    getCombinedVelocityModifiers(deltaT) {
        let result = 0;
        const modifierIndexesToRemove = [];

        this.#velocityModifiers.forEach((modifier, index) => {
            result += modifier.value;
            const remainingDuration = modifier.remainingDuration - deltaT;

            if (remainingDuration <= 0) {
                modifierIndexesToRemove.push({ modifier, index });
            }

            modifier.remainingDuration = remainingDuration;
        });

        modifierIndexesToRemove.forEach(({ modifier, index }) => {
            this.#velocityModifiers.splice(index, 1);
            modifier.endCallback?.();
        });

        return result;
    }

    get distance() {
        return this.#distance;
    }

    set distance(distance) {
        this.#distance = distance;
    }

    get hasGoodVelocityModifiers() {
        return !!this.#velocityModifiers.find((mod) => mod.value > 0);
    }

    get velocity() {
        return this.#velocity;
    }

    set velocity(velocity) {
        this.#velocity = velocity;
    }

    get minVelocity() {
        return this.#minVelocity;
    }

    get maxVelocity() {
        return this.#maxVelocity;
    }

    get startDistance() {
        return this.#startDistance;
    }

    get acceleration() {
        return this.#acceleration;
    }

    get startVelocity() {
        return this.#startVelocity;
    }

    get fullVelocityWithBonus() {
        return this.#fullVelocityWithBonus;
    }

    setStartKinematicsParams({ startDistance = 0, startVelocity = 0, acceleration = 0 }) {
        this.#distance = startDistance;
        this.#velocity = startVelocity;
        this.#acceleration = acceleration;
        this.#startDistance = startDistance;
        this.#startVelocity = startVelocity;
        this.#fullVelocityWithBonus = this.#velocity;
    }
}
